
import axiosInstance from "../../../axiosInstance";
import apiEndpoints from "../../../api";

export const getTaxRules = (societyId) => {
    // If societyId is present, we fetch specific rules which also includes defaults.
    // The user request specificed: GET /society/:id returns both)

    // Using simple concatenation as pattern logic is custom here
    let url = apiEndpoints.GET_TAX_RULES_API;
    if (societyId) {
        url = `${apiEndpoints.GET_TAX_RULES_API}/society/${societyId}`;
    }

    return axiosInstance.get(url);
};

export const createTaxRule = (data) => {
    return axiosInstance.post(apiEndpoints.CREATE_TAX_RULE_API, data);
};

export const updateTaxRule = (data) => {
    const { id, ...body } = data;
    const url = apiEndpoints.UPDATE_TAX_RULE_API.replace(':id', id);
    return axiosInstance.put(url, body);
};

export const deleteTaxRule = (id) => {
    const url = apiEndpoints.DELETE_TAX_RULE_API.replace(':id', id);
    return axiosInstance.delete(url);
};
